module.exports = __webpack_public_path__ + "img/Partners 8.2768a94a.png";